import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase/client";
import type { UserProfile } from "../types/domain";

export interface PlanStatus {
  plan: "free" | "premium"; policyVersion: string; aiUsed: number; aiLimit: number | null;
  storageUsed: number; storageLimit: number; storageMeasured: boolean; expiresAt: string | null;
  trialUsed: boolean; trialActive: boolean; cancelAtPeriodEnd: boolean; planSource?: string | null;
}
export function completeActive(profile: Pick<UserProfile, "plan" | "planExpiresAt"> | null | undefined, now = Date.now()): boolean {
  if (profile?.plan !== "premium") return false;
  const expiry = Date.parse(profile.planExpiresAt || "");
  return !profile.planExpiresAt || (Number.isFinite(expiry) && expiry > now);
}
export async function planCall(name = "getMundelyPlan"): Promise<PlanStatus> {
  return (await httpsCallable<Record<string, never>, PlanStatus>(functions, name)({})).data;
}
export async function uploadPlanFile(blob: Blob, path: string, operationId?: string): Promise<{ path: string; url: string; bytes: number }> {
  const bytes = new Uint8Array(await blob.arrayBuffer());
  let raw = "";
  for (let i = 0; i < bytes.length; i += 32768) raw += String.fromCharCode(...bytes.subarray(i, i + 32768));
  return (await httpsCallable<{ path: string; base64: string; mimeType: string; operationId?: string }, { path: string; url: string; bytes: number }>(functions, "uploadMundelyFile", { timeout: 180000 })({ path, base64: btoa(raw), mimeType: blob.type || "application/octet-stream", ...(operationId ? { operationId } : {}) })).data;
}
export async function deletePlanFile(path: string, expectedToken?: string, restoreEpoch?:string): Promise<{ deleted: boolean; pending?: boolean; stale?: boolean }> {
  return (await httpsCallable<{ path: string; expectedToken?: string; restoreEpoch?:string }, { deleted: boolean; pending?: boolean; stale?: boolean }>(functions, "deleteMundelyFile")({ path, ...(expectedToken ? { expectedToken } : {}), ...(restoreEpoch?{restoreEpoch}:{}) })).data;
}

export async function cancelPlanUpload(path: string, operationId: string): Promise<void> {
  await httpsCallable(functions, "deleteMundelyFile")({ path, operationId });
}
